// IMPORTAÇÃO DAS BIBLIOTECAS----------------------------------------------------------------------
import { useState, useEffect, useRef } from "react";
import { createPortal } from 'react-dom'; // para renderizar o modal de gravação fora da hierarquia do componente, garantindo que fique sobreposto a tudo
import { useTranslation } from 'react-i18next';



// IMPORTAÇÃO DOS ICONES---------------------------------------------------------------------------
import { useAppContext } from "../../../AppContext.js";
import { PiNotePencilFill, PiMicrophoneFill, PiStopCircleFill } from "react-icons/pi";
import { RxFontSize } from "react-icons/rx";
// import { RxFontFamily } from "react-icons/rx";
import { FcEmptyTrash, FcFilledFilter, FcMindMap } from "react-icons/fc";
import { BsStickiesFill, BsStickyFill, BsMicrosoft } from "react-icons/bs";
import { MdChevronRight, MdChevronLeft } from "react-icons/md";



// IMPORTAÇÃO DOS COMPONENTES----------------------------------------------------------------------
import { ClipLoader } from "react-spinners"; // Icone de Carregamento spinner
import styles from './nav.module.css';



// MODULO DA BARRA DE NAVEGAÇÃO INFERIOR-----------------------------------------------------------
function Nav({ openForm, openTrash, onFilterChange, onFontSizeChange, onVisualNotesChange, dragActive }) {

  // ESTADOS E VARIÁEIS----------------------------------------------------------------------------
  const { t } = useTranslation();// tradução
  const [filter, setFilter] = useState(() => { return localStorage.getItem("notepadFilter") || "all" });  // Filtro das notas
  const [showDropdown, setShowDropdown] = useState(false); // controla exibição do menu de opções de filtro
  const dropdownRef = useRef(null); // referência ao menu de opções de filtro
  const [fontSize, setFontSize] = useState(() => { return Number(localStorage.getItem("notepadFontSize")) || 12 }); // Tamanho da fonte das notas
  // const [fontType, setFontType] = useState(() => {return localStorage.getItem("notepadFontType") || "A"}); // Tipo da fonte das notas
  const [visualNotes, setVisualNotes] = useState(() => { return localStorage.getItem("tipoVisualizacao") || "notaDupla" }); // Tipo de visualização das notas
  const { isApp } = useAppContext(); // define se está sendo acessado pelo app ou pelo site
  const recognitionRef = useRef(null);
  const pressTimerRef = useRef(null);
  const longPressTriggeredRef = useRef(false);
  const isSpeechHoldingRef = useRef(false);
  const speechTranscriptRef = useRef('');
  const [isRecording, setIsRecording] = useState(false);
  const isRecordingRef = useRef(false);
  const audioCtxRef = useRef(null);
  const [isProcessingAudio, setIsProcessingAudio] = useState(false);
  const [previewTranscript, setPreviewTranscript] = useState('');
  // Estado do menu flutuante
  const [isMenuOpen, setIsMenuOpen] = useState(() => {
    const saved = localStorage.getItem("notepadMenuOpen");
    return saved !== null ? JSON.parse(saved) : false;
  });



  // FUNÇÕES---------------------------------------------------------------------------------------
  // Efeito para salvar o filtro selecionado das notas no localStorage
  useEffect(() => {
    localStorage.setItem("notepadFilter", filter);
  }, [filter]);

  // Listener para esconder a modal de gravação após processamento
  useEffect(() => {
    function handleTranscriptEnd() {
      setIsProcessingAudio(false);
      setIsRecording(false);
      isRecordingRef.current = false;
      setPreviewTranscript('');
    }
    window.addEventListener('speech-transcript-end', handleTranscriptEnd);
    return () => {
      window.removeEventListener('speech-transcript-end', handleTranscriptEnd);
    };
  }, []);

  // Efeito para salvar o estado do menu flutuante no localStorage
  useEffect(() => {
    localStorage.setItem("notepadMenuOpen", JSON.stringify(isMenuOpen));
  }, [isMenuOpen]);

  // Função para alterar o filtro através do componente pai
  function handleFilterChange(value) {
    setFilter(value);
    setShowDropdown(false);
    if (onFilterChange) {
      onFilterChange(value);
    }
  }

  // Efeito para fechar o menu de opções de filtro ao clicar fora
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Função para alterar o tamanho da fonte das notas através do componente pai
  function handleFontSizeChange() {
    const newSize = fontSize >= 16 ? 10 : fontSize + 1;
    setFontSize(newSize);
    localStorage.setItem("notepadFontSize", newSize);
    if (onFontSizeChange) {
      onFontSizeChange(newSize);
    }
  }

  // Função para alterar o tipo da fonte através do componente pai
  // function handleFontTypeChange() {
  //   const newFontType = fontType === "A" ? "B" : fontType === "B" ? "C" : fontType === "C" ? "D" : fontType === "D" ? "E" : "A";
  //   setFontType(newFontType);
  //   localStorage.setItem("notepadFontType", newFontType);
  //   if (onFontTypeChange) {
  //     onFontTypeChange(newFontType);
  //   }
  // }

  // Função para alterar o tipo de visualização das notas através do componente pai
  function handleVisualNotesChange() {
    // revesar entre notaUnica, notaDupla e grade
    const nextVisual = visualNotes === "notaUnica" ? "notaDupla" : visualNotes === "notaDupla" ? "grade" : "notaUnica";
    setVisualNotes(nextVisual);
    localStorage.setItem("tipoVisualizacao", nextVisual);
    if (onVisualNotesChange) {
      onVisualNotesChange(nextVisual);
    }
  }

  // Função para tocar beep curto usando Web Audio API
  function playBeep(frequency = 440, duration = 0.1, type = 'sine') {
    try {
      const AudioContext = window.AudioContext || window.webkitAudioContext;
      if (!AudioContext) return;
      if (!audioCtxRef.current) {
        audioCtxRef.current = new AudioContext();
      }
      const ctx = audioCtxRef.current;
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.type = type;
      o.frequency.value = frequency;
      g.gain.value = 0.001;
      o.connect(g);
      g.connect(ctx.destination);
      const now = ctx.currentTime;
      g.gain.setValueAtTime(0.0001, now);
      g.gain.exponentialRampToValueAtTime(0.25, now + 0.01);
      o.start(now);
      g.gain.exponentialRampToValueAtTime(0.0001, now + duration);
      o.stop(now + duration + 0.02);
    } catch (err) {
      // Não bloquear se áudio não puder ser criado
    }
  }

  // Função para solicitar permissão de microfone em tempo de execução
  async function requestMicrophonePermission() {
    try {
      if (navigator.permissions && navigator.permissions.query) {
        const permission = await navigator.permissions.query({ name: 'microphone' });
        if (permission.state === 'denied') {
          window.dispatchEvent(new CustomEvent('speech-error', { detail: 'microphone-permission-denied' }));
          return false;
        }
        if (permission.state === 'granted') {
          return true;
        }
      }
      // Se a API de permissões não existe, tenta usar a Web Speech API direto
      // (em alguns navegadores/WebViews, a permissão é solicitada ao chamar start())
      return true;
    } catch (err) {
      // Se houver erro, tenta mesmo assim
      return true;
    }
  }

  // Função para parar a gravação manualmente e processar o áudio capturado
  function handleStopRecording() {
    isRecordingRef.current = false;
    setPreviewTranscript('');
    if (recognitionRef.current) {
      try {
        recognitionRef.current.stop();
      } catch (err) {
        setIsRecording(false);
      }
    } else {
      // Se o reconhecimento não estiver ativo no momento (entre ciclos), processa o que já foi capturado
      const transcript = speechTranscriptRef.current.trim();
      if (transcript) {
        setIsProcessingAudio(true);
        window.dispatchEvent(new CustomEvent('speech-transcript', { detail: transcript }));
        speechTranscriptRef.current = '';
        playBeep(440, 0.12);
      } else {
        setIsRecording(false);
      }
      recognitionRef.current = null;
    }
  }

  // Função para iniciar a gravação de áudio
  function startSpeechRecognition() {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecognition) {
      window.dispatchEvent(new CustomEvent('speech-error', { detail: 'SpeechRecognition not supported' }));
      return;
    }

    const recognition = new SpeechRecognition();
    recognitionRef.current = recognition;
    recognition.lang = navigator.language || 'pt-BR';
    recognition.continuous = false;
    recognition.interimResults = true;
    recognition.maxAlternatives = 1;

    recognition.onstart = () => {
      setIsRecording(true);
      isRecordingRef.current = true;
      playBeep(880, 0.08);
    };

    recognition.onresult = (ev) => {
      let interim = '';
      let final = '';
      for (let i = ev.resultIndex; i < ev.results.length; i++) {
        const transcript = ev.results[i][0].transcript;
        if (ev.results[i].isFinal) {
          final += transcript;
        } else {
          interim += transcript;
        }
      }
      if (final) {
        speechTranscriptRef.current += final.trim() + ' ';
      }
      setPreviewTranscript(speechTranscriptRef.current + interim);
    };

    recognition.onerror = (err) => {
      window.dispatchEvent(new CustomEvent('speech-error', { detail: err.error || 'error' }));
    };

    recognition.onend = () => {
      if (!isRecordingRef.current) {
        const transcript = speechTranscriptRef.current.trim();
        if (transcript) {
          setIsProcessingAudio(true);
          window.dispatchEvent(new CustomEvent('speech-transcript', { detail: transcript }));
          speechTranscriptRef.current = '';
        } else {
          setIsRecording(false);
        }
        playBeep(440, 0.12);
        recognitionRef.current = null;
        return;
      }

      // mantém o modal de gravação visível e reinicia o reconhecimento enquanto isRecordingRef.current for true
      setTimeout(() => {
        if (isRecordingRef.current) {
          startSpeechRecognition();
        }
      }, 100);
    };

    recognition.start();
  }


  // HTML DO COMPONENTE-----------------------------------------------------------------------------
  return (
    <>
      {/* Menu flutuante com as opções */}
      {isMenuOpen && (
        <div className={styles.floatingMenu}>
          {/* alterar tamanho da fonte */}
          <div onClick={handleFontSizeChange} className={styles.iconsMen}>
            <RxFontSize className={styles.navIcons} title={t("Change font size")} />
            <label className={styles.iconLabel}>{t("font").slice(0, 6)}-{fontSize}</label>
          </div>

          {/* tipo de fonte */}
          {/* <div onClick={handleFontTypeChange} className={styles.iconsMen}>
          <RxFontFamily className={styles.navIcons} title={t("Change font type")} />
          <label className={styles.iconLabel}>{t("font").slice(0, 6)}-{fontType}</label>
        </div> */}

          {/* alterar tipo de visualização das notas */}
          <div onClick={handleVisualNotesChange} className={styles.iconsMen}>
            {visualNotes === "notaUnica" && <BsStickyFill className={`${styles.navIcons} ${styles.navIconsNotaUnica}`} title={t("Single note view")} />}
            {visualNotes === "notaDupla" && <BsStickiesFill className={`${styles.navIcons} ${styles.navIconsNotaDupla}`} title={t("Double note view")} />}
            {visualNotes === "grade" && <BsMicrosoft className={`${styles.navIcons} ${styles.navIconsGrade}`} title={t("Grid view")} />}
            <label className={styles.iconLabel}>{(visualNotes === "grade" ? t("grid") : visualNotes === "notaUnica" ? t("single") : t("double")).slice(0, 6)}</label>
          </div>

          {/* filtrar as notas */}
          <div style={{ position: "relative" }} ref={dropdownRef} onClick={() => setShowDropdown(!showDropdown)} className={styles.iconsMen}>
            <FcFilledFilter className={styles.navIcons} title={t("Filter notes")} />
            {showDropdown && (
              <div className={styles.navMenu} style={isApp ? { bottom: "60px" } : {}}>
                <ul className={styles.dropdownMenu}>
                  <li onClick={() => handleFilterChange("all")} className={filter === "all" ? styles.liActive : ""}>{t("All")}</li>
                  <li onClick={() => handleFilterChange("priority")} className={filter === "priority" ? styles.liActive : ""}>{t("Priority")}</li>
                  <li onClick={() => handleFilterChange("completed")} className={filter === "completed" ? styles.liActive : ""}>{t("Normal")}</li>
                  <li onClick={() => handleFilterChange("arquivo")} className={filter === "arquivo" ? styles.liActive : ""}>{t("File")}</li>
                </ul>
              </div>
            )}
            <label className={styles.iconSymbol}>{filter === "all" ? "" : filter === "priority" ? "p" : filter === "completed" ? "n" : "a"}</label>
            <label className={styles.iconLabel}>{t("filter").slice(0, 6)}</label>
          </div>

          {/* organizar notas */}
          <div onClick={() => dragActive()} className={styles.iconsMen}>
            <FcMindMap className={styles.navIcons} title={t("Organize notes")} />
            <label className={styles.iconLabel}>{t("order").slice(0, 8)}</label>
          </div>

          {/* lixeira */}
          <div onClick={() => openTrash(true)} className={styles.iconsMen}>
            <FcEmptyTrash className={styles.navIcons} title={t("trash")} />
            <label className={styles.iconLabel}>{t("trash").slice(0, 8)}</label>
          </div>
        </div>
      )}

      {/* Botão para recolher menu flutuante */}
      <div
        className={styles.toggleMenuButton}
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        title={isMenuOpen ? t("Collapse menu") : t("Expand menu")}
      >
        {isMenuOpen ? <MdChevronRight className={styles.toggleIcon} /> : <MdChevronLeft className={styles.toggleIcon} />}
      </div>

      {/* Botão flutuante para adicionar notas */}
      <div
        className={`${styles.floatingAddButton} ${isRecording ? styles.recording : ''}`}
        // long press para iniciar gravação de áudio
        onClick={(e) => {
          // previne trigger do click se foi long press
          if (longPressTriggeredRef.current) {
            longPressTriggeredRef.current = false;
            return;
          }
          if (isRecordingRef.current || isProcessingAudio) return;
          openForm(true);
        }}
        // eventos para detecção de pressão longa para gravação de áudio
        onPointerDown={(e) => {
          if (isRecordingRef.current || isProcessingAudio) return;
          // inicia timer para detectar pressão longa
          e.preventDefault();
          isSpeechHoldingRef.current = true;
          pressTimerRef.current = setTimeout(async () => {
            longPressTriggeredRef.current = true;

            // Solicita permissão de microfone em tempo de execução
            const hasPermission = await requestMicrophonePermission();
            if (!hasPermission) {
              return;
            }

            speechTranscriptRef.current = '';
            setPreviewTranscript('');
            startSpeechRecognition();
          }, 500); // 500ms para considerar pressão longa
        }}
        // limpa timer e estado ao soltar o botão
        onPointerUp={(e) => {
          e.preventDefault();
          clearTimeout(pressTimerRef.current);
          isSpeechHoldingRef.current = false;
        }}
        // se o usuário mover o cursor para fora do botão enquanto segura, cancela a gravação
        onPointerLeave={(e) => {
          // se o usuário ainda estiver segurando, mantém a gravação ativa
          clearTimeout(pressTimerRef.current);
          isSpeechHoldingRef.current = false;
        }}
        // se o usuário cancelar a interação (ex: pressionar ESC), cancela a gravação
        onPointerCancel={() => {
          clearTimeout(pressTimerRef.current);
          isSpeechHoldingRef.current = false;
        }}
      >
        <PiNotePencilFill className={styles.floatingAddIcon} title={t("Add new note")} />
        <div className={styles.micBadge} title={t("Hold to record audio")}>
          <PiMicrophoneFill size={12} className={styles.micBadgeIcon} />
        </div>
      </div>

      {isRecording && createPortal(
        <div className={styles.recordingOverlay} aria-hidden={false}>
          <div className={styles.recordingModal} role="status" aria-live="polite">
            {isProcessingAudio ? (
              <div className={styles.recordingSVG} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <ClipLoader color="#2575fc" size={64} />
              </div>
            ) : (
              <svg className={styles.recordingSVG} viewBox="0 0 160 160" xmlns="http://www.w3.org/2000/svg" aria-hidden>
                <defs>
                  <linearGradient id="micGrad" x1="0%" x2="100%" y1="0%" y2="100%">
                    <stop offset="0%" stopColor="#2575fc" />
                    <stop offset="100%" stopColor="#1565c0" />
                  </linearGradient>
                  <filter id="micShadow" x="-50%" y="-50%" width="200%" height="200%">
                    <feDropShadow dx="0" dy="8" stdDeviation="12" floodColor="#000" floodOpacity="0.35" />
                  </filter>
                </defs>

                {/* pulse ring */}
                <circle cx="80" cy="52" r="36" className={styles.recordingPulse} />

                {/* microphone body */}
                <g filter="url(#micShadow)">
                  <rect x="56" y="28" width="48" height="64" rx="24" className={styles.micBody} fill="url(#micGrad)" />
                  <ellipse cx="80" cy="28" rx="24" ry="12" className={styles.micInner} fill="rgba(255,255,255,0.22)" />
                  <rect x="72" y="48" width="16" height="28" rx="8" fill="rgba(255,255,255,0.08)" />
                  <g transform="translate(64,44)" opacity="0.22">
                    {Array.from({ length: 6 }).map((_, i) => (
                      <rect key={i} x={i * 6} y="0" width="4" height="24" rx="2" fill="#fff" />
                    ))}
                  </g>
                </g>

                {/* mic stand */}
                <rect x="74" y="96" width="12" height="22" rx="6" className={styles.micStand} />
                <rect x="60" y="116" width="40" height="10" rx="5" className={styles.micStand} />
              </svg>
            )}
            <div className={styles.recordingText}>{isProcessingAudio ? t('saving note') : t('transcribing audio')}</div>

            {!isProcessingAudio && (
              <div className={styles.visualizerContainer}>
                {[...Array(12)].map((_, i) => (
                  <div key={i} className={styles.visualizerBar} />
                ))}
              </div>
            )}

            {!isProcessingAudio && previewTranscript && (
              <div className={styles.previewScroll}>
                {previewTranscript}
              </div>
            )}

            {!isProcessingAudio ? (
              <button
                className={styles.stopRecordingBtn}
                onClick={handleStopRecording}
                aria-label={t("Stop recording")}
              >
                <PiStopCircleFill size={52} />
                <span className={styles.stopLabel}>{t('Stop')}</span>
              </button>
            ) : (
              <div className={styles.recordingLabelSmall}>{t('wait')}</div>
            )}
          </div>
        </div>,
        document.body
      )}

    </>
  );


}

export default Nav;